import { Component, OnInit } from '@angular/core';
import{UserService} from"../../services/user/user.service";
import { User } from 'src/app/model/user.model';
import { Identifiers } from '@angular/compiler';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

profiledata:User;
profiledataany:any;


  constructor(private UserService:UserService) { }

  ngOnInit() {
    this.UserService.getUserProfile().subscribe(
      (data)=>{
       
        this.profiledataany=data;
       this.profiledata=this.profiledataany;
       console.log(this.profiledataany);
       this.profiledata.fullName=this.profiledataany.fullName;
       this.profiledata.email=this.profiledataany.email;
       this.profiledata.phoneNumber=this.profiledataany.phoneNumber;
       console.log(this.profiledata.fullName);
        
        
      }
    )
  }

}
